import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Form, Spin } from 'antd';
import Drawer from 'components/AntEnhancement/Drawer';
import StockMovementForm from 'components/forms/inventory/stockMovements/StockMovementForm';
import localeTranslator from 'library/Hocs/LocalTranslator';
import { StockMovement } from 'models';
import services from 'services';
import './StockMovementDrawer.css';
var StockMovementDrawer = function (props) {
    var visiable = props.visiable, onCloseDrawer = props.onCloseDrawer, t = props.translate;
    var movement = useState(function () { return new StockMovement(); })[0];
    var _a = useState(false), saving = _a[0], setSaving = _a[1];
    var form = Form.useForm()[0];
    var stockMovementService = services.stockMovementService, productService = services.productService;
    var createStockMovement = stockMovementService.useCreateStockMovement().mutate;
    var products = productService.useMiniProducts(visiable).data;
    var _b = stockMovementService.useMetaInfo(visiable), metaInfo = _b.data, metaFailed = _b.isError;
    useEffect(function () {
        if (!visiable)
            return;
        movement.setProductId(0);
        movement.setMoveType('');
        movement.setQuantity(0);
        movement.setPrice(0);
        movement.setPriceType('');
        movement.setEntityId(0);
        movement.started_at = '';
        form.resetFields();
        setSaving(false);
    }, [visiable, movement, form]);
    var onSubmit = function () {
        if (saving || !metaInfo)
            return;
        setSaving(true);
        createStockMovement({ stockMovement: movement, successMessage: t('StockMovementCreated'), stayOnPage: true }, {
            onSuccess: function () {
                setSaving(false);
                onCloseDrawer();
            },
            onError: function () { return setSaving(false); }
        });
    };
    return (_jsx(Drawer, { title: null, placement: "right", open: visiable, onClose: onCloseDrawer, closable: false, destroyOnClose: true, width: 520, rootClassName: "smv-drawer", className: "smv-drawer", children: _jsxs(Form, { form: form, layout: "vertical", className: "smv-drawer__shell", requiredMark: false, onFinish: onSubmit, children: [_jsxs("header", { className: "smv-drawer__header", children: [_jsxs("div", { className: "smv-drawer__title-block", children: [_jsx("span", { className: "smv-drawer__dot", "aria-hidden": true }), _jsxs("div", { children: [_jsx("h2", { className: "smv-drawer__title", children: t('title') }), _jsx("p", { className: "smv-drawer__subtitle", children: t('subtitle') })] })] }), _jsx("button", { type: "button", className: "smv-drawer__close", onClick: onCloseDrawer, "aria-label": t('common:buttons.close'), children: _jsx(CloseOutlined, {}) })] }), _jsx("div", { className: "smv-drawer__body", children: metaInfo ? (_jsx(StockMovementForm, { stockMovement: movement, metaInfo: metaInfo, products: products || [] })) : metaFailed ? (_jsx("p", { className: "smv-drawer__notice", children: t('loadError') })) : (_jsx("div", { className: "smv-drawer__loading", children: _jsx(Spin, {}) })) }), _jsxs("footer", { className: "smv-drawer__footer", children: [_jsx("button", { type: "button", className: "smv-drawer__btn smv-drawer__btn--ghost", onClick: onCloseDrawer, children: t('common:buttons.cancel') }), _jsxs("button", { type: "submit", className: "smv-drawer__btn smv-drawer__btn--primary", disabled: saving || !metaInfo, children: [_jsx(CheckOutlined, {}), _jsx("span", { children: saving ? t('saving') : t('common:buttons.submit') })] })] })] }) }));
};
export default localeTranslator(StockMovementDrawer, 'stockMovementForm');
